import React, { useEffect, useState } from 'react';
import { bool, func, number, string } from 'prop-types';
import { Form as FinalForm, FormSpy } from 'react-final-form';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import { propTypes } from '../../../util/types';
import { numberAtLeast, required } from '../../../util/validators';
import { PURCHASE_PROCESS_NAME } from '../../../transactions/transaction';

import { ToastContainer, toast } from 'react-toastify';

import {
  Form,
  FieldSelect,
  FieldTextInput,
  InlineTextButton,
  PrimaryButton,
  Modal,
  Button,
  H3,
  H6,
} from '../../../components';


//import { pushToPath } from '../../../util/urlHelpers';

import EstimatedCustomerBreakdownMaybe from '../EstimatedCustomerBreakdownMaybe';

import './Toast.css';
import css from './ProductOrderForm.module.css';

const sharetribeSdk = require('sharetribe-flex-sdk');
const sdk = sharetribeSdk.createInstance({
  clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
});

//import mitt, { Emitter } from 'mitt';


// Browsers can't render huge number of select options.
// (stock is shown inside select element)
// Note: input element could allow ordering bigger quantities
const MAX_QUANTITY_FOR_DROPDOWN = 100;

const handleFetchLineItems = ({
  quantity,
  deliveryMethod,
  listingId,
  isOwnListing,
  fetchLineItemsInProgress,
  onFetchTransactionLineItems,
}) => {
  const stockReservationQuantity = Number.parseInt(quantity, 10);
  const isBrowser = typeof window !== 'undefined';
  if (isBrowser && stockReservationQuantity && deliveryMethod && !fetchLineItemsInProgress) {
    onFetchTransactionLineItems({
      orderData: { stockReservationQuantity, deliveryMethod },
      listingId,
      isOwnListing,
    });
  }
};

const renderForm = formRenderProps => {
  const [mounted, setMounted] = useState(false);
  const {
    // FormRenderProps from final-form
    handleSubmit,
    form: formApi,

    // Custom props passed to the form component
    intl,
    formId,
    currentStock,
    hasMultipleDeliveryMethods,
    listingId,
    isOwnListing,
    onFetchTransactionLineItems,
    onContactUser,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    price,
    marketplaceName,
    values,
    listing,
    currentUser,
    history,
    pickupEnabled,
    shippingEnabled,
    isRestaurantOnHold,
  } = formRenderProps;

  useEffect(() => {
    require('react-toastify/dist/ReactToastify.css');
  }, []);

  const [sameVendorWarningModalOpen, setSameVendorWarningModalOpen] = useState(false);
  const [emptyCartModalOpen, setEmptyCartModalOpen] = useState(false);


  // Note: don't add custom logic before useEffect
  useEffect(() => {
    setMounted(true);

    // Side-effect: fetch line-items after mounting if possible
    const { quantity, deliveryMethod } = values;
    if (quantity && !formRenderProps.hasMultipleDeliveryMethods) {
      handleFetchLineItems({
        quantity,
        deliveryMethod,
        listingId,
        isOwnListing,
        fetchLineItemsInProgress,
        onFetchTransactionLineItems,
      });
    }
  }, []);

  // If form values change, update line-items for the order breakdown
  const handleOnChange = formValues => {
    const { quantity, deliveryMethod } = formValues.values;
    if (mounted) {
      handleFetchLineItems({
        quantity,
        deliveryMethod,
        listingId,
        isOwnListing,
        fetchLineItemsInProgress,
        onFetchTransactionLineItems,
      });
    }
  };

  // In case quantity and deliveryMethod are missing focus on that select-input.
  // Otherwise continue with the default handleSubmit function.
  const handleFormSubmit = e => {

    // TODO check here to not be default-booking
    // just default-purchase
    // for the other just go to the checkout page

    // prevent form submit
    e.preventDefault();

    const emptyPromise = new Promise((resolve, reject) => {
      resolve();
    });
    return emptyPromise.then(() => {

      let quantities = window.sessionStorage.getItem('quantities');
      let listingIds = window.sessionStorage.getItem('listingIds');
      let quantity = 0;
      if (window.sessionStorage.getItem('listingIds') === null) {
        listingIds=listingId.uuid;
        window.sessionStorage.setItem('listingIds', listingIds);
        //quantity = 1;
        window.sessionStorage.setItem('quantities', 1);
      }
      else {
        let listingIds1 = listingIds.split(',');
        if (!listingIds1.includes(listingId.uuid)) {
          listingIds = listingIds + ',' + listingId.uuid;
          quantities = quantities + ',' + '1';
          
          window.sessionStorage.setItem('listingIds', listingIds);
          window.sessionStorage.setItem('quantities', quantities);
        } else {
          const listingsArray = listingIds.split(',');
          const index = listingsArray.indexOf(listingId.uuid);

          let quantitiesArray = quantities.split(',');
          let quantity = quantitiesArray[index];

          quantitiesArray[index] = Number(quantity) + 1;
          quantities = quantitiesArray.join(',');
          window.sessionStorage.setItem('quantities', quantities);
        }      
      } 

      window.sessionStorage.getItem('quantities').split(',')
        .map(q => quantity += Number(q));
      
      window.emitter.emit('quantity', { quantity: quantity});
      window.sessionStorage.setItem('quantity', quantity);

      toast.success('Added to basket!', {
        position: 'top-right',
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setTimeout(function() {
        return history.push('/s');
      }, 2500);
    
    
  });
  
    
    // const { quantity, deliveryMethod } = values || {};
    // if (!quantity || quantity < 1) {
    //   e.preventDefault();
    //   // Blur event will show validator message
    //   formApi.blur('quantity');
    //   formApi.focus('quantity');
    if (currentUser) {
      const { quantity, deliveryMethod } = values || {};
      if (!quantity || quantity < 1) {
        e.preventDefault();
        // Blur event will show validator message
        formApi.blur('quantity');
        formApi.focus('quantity');
      } else if (!deliveryMethod) {
        e.preventDefault();
        // Blur event will show validator message
        formApi.blur('deliveryMethod');
        formApi.focus('deliveryMethod');
      } else {
        e.preventDefault();
        const currentListing = listing;
        return sdk.currentUser
          .show()
          .then(res => {
            const currentShoppingCart = res.data.data.attributes.profile.publicData.shoppingCart
              ? res.data.data.attributes.profile.publicData.shoppingCart
              : [];

            const currentShoppingCartUnwrapped = currentShoppingCart.map(item => {
              return {
                listing: typeof item.listing === 'string' ? JSON.parse(item.listing) : item.listing,
                checkoutValues:
                  typeof item.checkoutValues === 'string'
                    ? JSON.parse(item.checkoutValues)
                    : item.checkoutValues,
              };
            });
            const isFromSameVendor =
              currentShoppingCartUnwrapped.length === 0 ||
              currentShoppingCartUnwrapped.find(item => {
                return item.listing.author.id.uuid === currentListing.author.id.uuid;
              });

            if (isFromSameVendor) {
              const isAlreadyInTheBasket = currentShoppingCartUnwrapped.find(i => {
                return i.listing.id.uuid === currentListing.id.uuid;
              });

              if (isAlreadyInTheBasket) {
                // UPDATE EXISTING ITEM QUANTITY
                const updatedShoppingCard = currentShoppingCartUnwrapped.map(i => {
                  if (i.listing.id.uuid === currentListing.id.uuid) {
                    i.checkoutValues.quantity = (
                      Number(i.checkoutValues.quantity) + Number(quantity)
                    ).toString();
                    return i;
                  } else {
                    return i;
                  }
                });

                const stringifyUpdatedShoppingCart = updatedShoppingCard.map(item => {
                  return {
                    listing: JSON.stringify(item.listing),
                    checkoutValues: JSON.stringify(item.checkoutValues),
                  };
                });

                return sdk.currentUser
                  .updateProfile({
                    publicData: {
                      shoppingCart: [...stringifyUpdatedShoppingCart],
                    },
                  })
                  .then(res => {
                    toast.success('Added to basket!', {
                      position: 'top-right',
                      autoClose: 1500,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });

                    setTimeout(function() {
                      return history.push('/s');
                    }, 2500);
                  })
                  .catch(e => console.log(e));
              } else {
                //ADD NEW ITEM TO CART

                const shoppingCartItem = {
                  listing: JSON.stringify({ ...currentListing }),
                  checkoutValues: JSON.stringify({ ...values }),
                };

                return sdk.currentUser
                  .updateProfile({
                    publicData: {
                      shoppingCart: [...currentShoppingCart, shoppingCartItem],
                    },
                  })
                  .then(res => {
                    toast.success('Added to basket!', {
                      position: 'top-right',
                      autoClose: 1500,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });
                    setTimeout(function() {
                      return history.push('/s');
                    }, 2500);
                  })
                  .catch(e => console.log(e));
              }
            } else {
              setSameVendorWarningModalOpen(true);
            }
          })
          .catch(e => console.log(e));

        // handleSubmit(e);
      }
  //   } else if (!deliveryMethod) {
  //     e.preventDefault();
  //     // Blur event will show validator message
  //     formApi.blur('deliveryMethod');
  //     formApi.focus('deliveryMethod');
  //   } else {
  //     handleSubmit(e);
  //   }
  // };
} else {
  handleSubmit(e);
  const { quantity, deliveryMethod } = values || {};
  if (!quantity || quantity < 1) {
    e.preventDefault();
    // Blur event will show validator message
    formApi.blur('quantity');
    formApi.focus('quantity');
  } else if (!deliveryMethod) {
    e.preventDefault();
    // Blur event will show validator message
    formApi.blur('deliveryMethod');
    formApi.focus('deliveryMethod');
  } else {
    e.preventDefault();
    const currentListing = listing;

    const currentShoppingCart = JSON.parse(window.sessionStorage.getItem('shoppingCart')) ?? [];

    const currentShoppingCartUnwrapped = currentShoppingCart.map(item => {
      return {
        listing: typeof item.listing === 'string' ? JSON.parse(item.listing) : item.listing,
        checkoutValues:
          typeof item.checkoutValues === 'string'
            ? JSON.parse(item.checkoutValues)
            : item.checkoutValues,
      };
    });
    const isFromSameVendor =
      currentShoppingCartUnwrapped.length === 0 ||
      currentShoppingCartUnwrapped.find(item => {
        return item.listing.author.id.uuid === currentListing.author.id.uuid;
      });

    if (isFromSameVendor) {
      const isAlreadyInTheBasket = currentShoppingCartUnwrapped.find(i => {
        return i.listing.id.uuid === currentListing.id.uuid;
      });

      if (isAlreadyInTheBasket) {
        // UPDATE EXISTING ITEM QUANTITY
        const updatedShoppingCard = currentShoppingCartUnwrapped.map(i => {
          if (i.listing.id.uuid === currentListing.id.uuid) {
            i.checkoutValues.quantity = (
              Number(i.checkoutValues.quantity) + Number(quantity)
            ).toString();
            return i;
          } else {
            return i;
          }
        });

        const stringifyUpdatedShoppingCart = updatedShoppingCard.map(item => {
          return {
            listing: JSON.stringify(item.listing),
            checkoutValues: JSON.stringify(item.checkoutValues),
          };
        });

        window.sessionStorage.setItem(
          'shoppingCart',
          JSON.stringify([...stringifyUpdatedShoppingCart])
        );
        toast.success('Added to basket!', {
          position: 'top-right',
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setTimeout(function() {
          return history.push('/s');
        }, 2500);
      } else {
        //ADD NEW ITEM TO CART

        const shoppingCartItem = {
          listing: JSON.stringify({ ...currentListing }),
          checkoutValues: JSON.stringify({ ...values }),
        };

        window.sessionStorage.setItem(
          'shoppingCart',
          JSON.stringify([...currentShoppingCart, shoppingCartItem])
        );
        toast.success('Added to basket!', {
          position: 'top-right',
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setTimeout(function() {
          return history.push('/s');
        }, 2500);
      }
    } else {
      setSameVendorWarningModalOpen(true);
    }

    // handleSubmit(e);
  }
}
};

const clearBasket = () => {
if (typeof window !== 'undefined') {
  if (currentUser) {
    return sdk.currentUser
      .updateProfile({
        publicData: {
          shoppingCart: [],
        },
      })
      .then(res => {
        window.location.reload();
      })
      .catch(e => console.log(e));
  } else {
    return window.sessionStorage.setItem('shoppingCart', JSON.stringify([]));
  }
}
};


  const breakdownData = {};
  const showBreakdown =
    breakdownData && lineItems && !fetchLineItemsInProgress && !fetchLineItemsError;

  const showContactUser = typeof onContactUser === 'function';

  const onClickContactUser = e => {
    e.preventDefault();
    onContactUser();
  };

  const contactSellerLink = (
    <InlineTextButton onClick={onClickContactUser}>
      <FormattedMessage id="ProductOrderForm.finePrintNoStockLinkText" />
    </InlineTextButton>
  );
  const quantityRequiredMsg = intl.formatMessage({ id: 'ProductOrderForm.quantityRequired' });

  const hasStock = currentStock && currentStock > 0;
  const selectableStock =
    currentStock > MAX_QUANTITY_FOR_DROPDOWN ? MAX_QUANTITY_FOR_DROPDOWN : currentStock;
  const quantities = hasStock ? [...Array(selectableStock).keys()].map(i => i + 1) : [];
  const hasNoStockLeft = typeof currentStock != null && currentStock === 0;
  const hasOneItemLeft = typeof currentStock != null && currentStock === 1;

  const submitInProgress = fetchLineItemsInProgress;
  const submitDisabled = !hasStock;

  const shoppingCartFromSession =
    typeof window !== 'undefined' ? JSON.parse(window.sessionStorage.getItem('shoppingCart')) : [];

  const currentShopCart = currentUser
    ? currentUser.attributes.profile.publicData.shoppingCart
      ? currentUser.attributes.profile.publicData.shoppingCart
      : []
    : shoppingCartFromSession ?? [];

  const currentShopCartUnwrapped = currentShopCart.map(item => {
    return {
      listing: typeof item.listing === 'string' ? JSON.parse(item.listing) : item.listing,
      checkoutValues:
        typeof item.checkoutValues === 'string'
          ? JSON.parse(item.checkoutValues)
          : item.checkoutValues,
    };
  });

  // const hostIdOfFirstItem =
  //   currentShopCartUnwrapped.length > 0
  //     ? currentShopCartUnwrapped[0].listing.author.id.uuid
  //     : false;

  const deliveryMethodOfItemsAdded =
    currentShopCartUnwrapped && currentShopCartUnwrapped.length > 0
      ? currentShopCartUnwrapped[0].checkoutValues.deliveryMethod
      : false;

  const pickup = pickupEnabled
    ? [
        {
          value: 'pickup',
          label: 'ProductOrderForm.pickupOption',
        },
      ]
    : [];

  const shipping = shippingEnabled
    ? [
        {
          value: 'shipping',
          label: 'ProductOrderForm.shippingOption',
        },
      ]
    : [];

  const deliveryMethodsOptions = [...pickup, ...shipping];

  const missingDeliveryMethod = deliveryMethodOfItemsAdded
    ? !!!deliveryMethodsOptions.find(x => {
        return x.value === deliveryMethodOfItemsAdded;
      })
    : false;


  return (
    <Form onSubmit={handleFormSubmit}>
      <FormSpy subscription={{ values: true }} onChange={handleOnChange} />
      {hasNoStockLeft ? null : hasOneItemLeft ? (
        <FieldTextInput
          id={`${formId}.quantity`}
          className={css.quantityField}
          name="quantity"
          type="hidden"
          validate={numberAtLeast(quantityRequiredMsg, 1)}
        />
      ) : (
        <FieldSelect
          id={`${formId}.quantity`}
          className={css.quantityField}
          name="quantity"
          disabled={!hasStock}
          label={intl.formatMessage({ id: 'ProductOrderForm.quantityLabel' })}
          validate={numberAtLeast(quantityRequiredMsg, 1)}
        >
          <option disabled value="">
            {intl.formatMessage({ id: 'ProductOrderForm.selectQuantityOption' })}
          </option>
          {quantities.map(quantity => (
            <option key={quantity} value={quantity}>
              {intl.formatMessage({ id: 'ProductOrderForm.quantityOption' }, { quantity })}
            </option>
          ))}
        </FieldSelect>
      )}

      {hasNoStockLeft ? null : hasMultipleDeliveryMethods ? (
        <FieldSelect
          id={`${formId}.deliveryMethod`}
          className={css.deliveryField}
          name="deliveryMethod"
          disabled={!hasStock}
          label={intl.formatMessage({ id: 'ProductOrderForm.deliveryMethodLabel' })}
          validate={required(intl.formatMessage({ id: 'ProductOrderForm.deliveryMethodRequired' }))}
        >
          <option disabled value="">
            {intl.formatMessage({ id: 'ProductOrderForm.selectDeliveryMethodOption' })}
          </option>
          <option value={'pickup'}>
            {intl.formatMessage({ id: 'ProductOrderForm.pickupOption' })}
          </option>
          <option value={'shipping'}>
            {intl.formatMessage({ id: 'ProductOrderForm.shippingOption' })}
          </option>
        </FieldSelect>
      ) : (
        <div className={css.deliveryField}>
          <H3 rootClassName={css.singleDeliveryMethodLabel}>
            {intl.formatMessage({ id: 'ProductOrderForm.deliveryMethodLabel' })}
          </H3>
          <p className={css.singleDeliveryMethodSelected}>
            {values.deliveryMethod === 'shipping'
              ? intl.formatMessage({ id: 'ProductOrderForm.shippingOption' })
              : intl.formatMessage({ id: 'ProductOrderForm.pickupOption' })}
          </p>
          <FieldTextInput
            id={`${formId}.deliveryMethod`}
            className={css.deliveryField}
            name="deliveryMethod"
            type="hidden"
          />
        </div>
      )}

      {showBreakdown ? (
        <div className={css.breakdownWrapper}>
          <H6 as="h3" className={css.bookingBreakdownTitle}>
            <FormattedMessage id="ProductOrderForm.breakdownTitle" />
          </H6>
          <hr className={css.totalDivider} />
          <EstimatedCustomerBreakdownMaybe
            breakdownData={breakdownData}
            lineItems={lineItems}
            currency={price.currency}
            marketplaceName={marketplaceName}
            processName={PURCHASE_PROCESS_NAME}
          />
        </div>
      ) : null}

      <div className={css.submitButton}>
        <PrimaryButton type="submit" inProgress={submitInProgress} disabled={submitDisabled}>
          {hasStock ? (
            // <FormattedMessage id="ProductOrderForm.ctaButton" />
            <FormattedMessage id="BookingDatesForm.addToCart" />
          ) : (
            <FormattedMessage id="ProductOrderForm.ctaButtonNoStock" />
          )}
        </PrimaryButton>
      </div>
      <p className={css.finePrint}>
        {hasStock ? (
          <FormattedMessage id="ProductOrderForm.finePrint" />
        ) : showContactUser ? (
          <FormattedMessage id="ProductOrderForm.finePrintNoStock" values={{ contactSellerLink }} />
        ) : null}
      </p>
    </Form>
  );
};

const ProductOrderForm = props => {
  const intl = useIntl();
  const { price, currentStock, pickupEnabled, shippingEnabled } = props;

  // Should not happen for listings that go through EditListingWizard.
  // However, this might happen for imported listings.
  if (!pickupEnabled && !shippingEnabled) {
    return (
      <p className={css.error}>
        <FormattedMessage id="ProductOrderForm.noDeliveryMethodSet" />
      </p>
    );
  }

  const hasOneItemLeft = currentStock && currentStock === 1;
  const quantityMaybe = hasOneItemLeft ? { quantity: '1' } : {};
  const singleDeliveryMethodAvailableMaybe =
    shippingEnabled && !pickupEnabled
      ? { deliveryMethod: 'shipping' }
      : !shippingEnabled && pickupEnabled
      ? { deliveryMethod: 'pickup' }
      : {};
  const hasMultipleDeliveryMethods = pickupEnabled && shippingEnabled;
  const initialValues = { ...quantityMaybe, ...singleDeliveryMethodAvailableMaybe };

  return (
    <FinalForm
      initialValues={initialValues}
      hasMultipleDeliveryMethods={hasMultipleDeliveryMethods}
      {...props}
      intl={intl}
      render={renderForm}
    />
  );
};

ProductOrderForm.defaultProps = {
  rootClassName: null,
  className: null,
  price: null,
  currentStock: null,
  listingId: null,
  isOwnListing: false,
  lineItems: null,
  fetchLineItemsError: null,
};

ProductOrderForm.propTypes = {
  rootClassName: string,
  className: string,

  marketplaceName: string.isRequired,

  // form
  formId: string.isRequired,
  onSubmit: func.isRequired,

  // listing
  listingId: propTypes.uuid,
  price: propTypes.money,
  currentStock: number,
  isOwnListing: bool,

  // line items
  lineItems: propTypes.lineItems,
  onFetchTransactionLineItems: func.isRequired,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,

  // other
  onContactUser: func,
};

export default ProductOrderForm;
